import {
  UseInfiniteQueryOptions,
  useInfiniteQuery,
} from '@tanstack/react-query'

import {
  MessageList,
  QueryMessagesArgs,
  QueryMessagesByCursorArgs,
} from '@tribeplatform/gql-client/types'

import { useTribeClient } from '../../useTribeClient.js'
import { getMessagesKey } from '../../utils/keys/messaging.key.js'

export const useMessages = (options: {
  variables: QueryMessagesArgs
  useInfiniteQueryOptions?: UseInfiniteQueryOptions<MessageList>
  reverseMessages?: boolean
}) => {
  const { variables, useInfiniteQueryOptions, reverseMessages } = options

  const { client } = useTribeClient()
  const messagesKey = getMessagesKey({ variables })

  return useInfiniteQuery(
    messagesKey,
    ({ pageParam }: { pageParam?: QueryMessagesByCursorArgs }) => {
      if (pageParam && 'cursor' in pageParam) {
        return client.messaging.messagesByCursor(pageParam)
      }

      return client.messaging.messages({
        ...variables,
      })
    },
    {
      ...useInfiniteQueryOptions,
      select: data => {
        if (reverseMessages) {
          return {
            pageParams: data.pageParams,
            pages: data.pages.map(messageList => {
              const sortedList: MessageList = {
                data: [...messageList.data].reverse(),
                pageInfo: messageList.pageInfo,
              }
              return sortedList
            }),
          }
        }
        return data
      },
      getNextPageParam: (
        lastPage,
        _pages,
      ): QueryMessagesByCursorArgs | undefined => {
        if (lastPage.pageInfo.endCursor) {
          return {
            chatId: variables.chatId,
            limit: variables.limit,
            cursor: lastPage.pageInfo.endCursor,
          } as QueryMessagesByCursorArgs
        }
        return undefined
      },
    },
  )
}
